module.exports = __webpack_public_path__ + "img/zhongshan9.5fc30c48.jpg";